import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CompetitionEvent } from '../models/competitionEvent';

@Injectable({
    providedIn: 'root'
})
export class CompetitionEventsService {
    private readonly baseUrl: string = '/api/v1/competitions';
    constructor(private http: HttpClient) {}

    getUpcomingEvents(page: number, pageSize: number): Observable<CompetitionEvent[]> {
        let params = new HttpParams()
            .set('page', page.toString())
            .set('pageSize', pageSize.toString());

            let url: string = `${this.baseUrl}/upcoming`;

        return this.http.get<CompetitionEvent[]>(url, { params });
    }
}